import { ApolloProvider } from '@apollo/client';
import { createBrowserHistory } from 'history';
import moment from 'moment';
import 'moment/locale/pt-br';
import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from 'redux-persist/integration/react';

import client from './client/apollo';
import Notify from './lib/components/Notify';
import store, { persistor } from './state/redux';
import ExamAnalysisFreePage from './views/ExamAnalysisFreePage';

moment.locale('pt-BR');

toast.configure({
  autoClose: 3000,
});

const history = createBrowserHistory();

const App: FC = () => {
  return (
    <Router history={history}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ApolloProvider client={client}>
            <Notify>
              <Switch>
                <Route
                  path="/analise-de-provas"
                  component={ExamAnalysisFreePage}
                />
              </Switch>
            </Notify>
          </ApolloProvider>
        </PersistGate>
      </Provider>
    </Router>
  );
};

export default App;
